import debounce from 'lodash/debounce';
import { enrollmentResource } from '../../../../infrastructure/http/EnrollmentResource';

const validateOnServer = debounce(async (taxId: string, isGovernmentId: boolean, resolve: (message: string) => void) => {
  const response = await enrollmentResource.post('/account/gov-id-taken', { taxId, isGovernmentId });
  resolve(response.data && 'UniqueGovIdError');
}, 1000);

export const noDuplicateGovIdValidator = async (taxId: string) => {
  return new Promise<string>(resolve => {
    validateOnServer(taxId.trim(), true, resolve);
  });
};
